import { Box, Typography } from "@mui/material";
import ListCards from "./ListCards";
import { useState } from "react";

const SuitItem = ({ suit }: { suit: any }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Box key={suit.id} marginTop="10px">
      <Typography
        variant="subtitle1"
        color="primary"
        sx={{
          fontWeight: "bold",
          cursor: "pointer",
        }}
        onClick={() => {
          setIsOpen((prev) => !prev);
        }}
      >
        {suit.title}
      </Typography>
      {isOpen && <ListCards suidId={suit.id} />}
    </Box>
  );
};

export default SuitItem;
